module.exports = __webpack_public_path__ + "media/images/icon__info--white@2x-bcb3d278f27a1688b4041f01d5dffb2b.png";